const project = {
  slug: "linkedin-leadgen-automation",
  title: "LinkedIn Lead Generation Automation",
  oneLiner: "Scrapes, enriches, personalizes, sends outreach, and updates sheet.",
  role: ["Automation Engineer", "AI Workflow Designer"],
  category: "AI/ML",
  clientOrOrg: "Automation Engineering (n8n + OpenAI Workflows)",
  timeframe: { start: "2025-02", status: "Shipped" },
  domain: ["Automation", "SalesOps", "AI"],
  tech: ["n8n", "OpenAI", "SERP APIs", "Sheets", "LinkedIn"],
  links: {},
  impact: [
    "End-to-end leadgen pipeline with scraping, enrichment, personalized GPT outreach.",
    "Reduced manual prospecting time while keeping outreach contextual."
  ],
  responsibilities: [
    "Built multi-source enrichment (profiles, posts, jobs, SERP, actors)",
    "Designed GPT prompts for personalized connection requests",
    "Automated Sheets updates and error handling"
  ],
  features: [
    "Profile scraping & enrichment",
    "Personalized outreach generation",
    "Auto connection requests",
    "Sheets sync"
  ],
  architecture: [
    "n8n orchestrations for data fetch + enrichment",
    "OpenAI prompt chains for message generation",
    "Webhooks + Sheets for status updates"
  ],
  seo: {
    title: "LinkedIn Lead Generation Automation - n8n + OpenAI",
    description: "Automated lead gen pipeline that scrapes, enriches, and sends GPT-personalized outreach with Sheets sync."
  },
  cover: "/assets/linkedin-leadgen/linkedin-leadgen.png"
};

export default project;
